import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { useNavigate } from 'react-router-dom'
import { AsyncView } from '@aboutbits/react-toolbox'
import { HeaderArea, HeaderTitle } from '../../../shared/header'
import { HeaderBackAction } from '../../../shared/header/HeaderBackAction'
import { IconClose } from '../../../shared/svgs'
import { useGetAddressById } from '../db/addresses'
import { translationsShared } from '../../../shared/translations/translationsShared'
import { translationsAddress } from '../translations/translationsAddress'
import { AddressEditSection } from './AddressEditSection'

const AddressEdit: React.FC<{ id: string }> = ({ id }) => {
  const intl = useIntl()
  const navigate = useNavigate()

  const { data } = useGetAddressById(id)

  return (
    <>
      <HeaderArea
        navigation={
          <HeaderBackAction
            label={intl.formatMessage(translationsShared.goBack)}
            onClick={() => navigate(-1)}
            icon={IconClose}
          />
        }
      >
        <HeaderTitle>
          <FormattedMessage {...translationsAddress.editTitle} />
        </HeaderTitle>
      </HeaderArea>
      {data && (
        <AsyncView
          data={data}
          renderSuccess={(data) => <AddressEditSection data={data} />}
        />
      )}
    </>
  )
}

export { AddressEdit }
